/**
 * CDN ecommerce click detection
 *
 * f-find-elem.js matches every click against these element-attribute maps
 * (defined by an_analyzify.js when it loads) and fires add_to_cart,
 * remove_from_cart, begin_checkout, add_to_wishlist and select_item for
 * matching Liquid-theme controls. In headless the SDK's explicit track calls
 * report these events, so detection only produces duplicates and false hits.
 */

/** Attribute maps behind the CDN's ecommerce click detection. */
export const ECOMMERCE_CLICK_MAPS = [
  'addtocart_btn_attributes',
  'wishlist_btn_attributes',
  'removefromcart_btn_attributes',
  'cart_increase_btn_attributes',
  'cart_decrease_btn_attributes',
  'checkout_btn_attributes',
  'accelerated_checkout_btn_attributes',
  'accelerated_checkout_cart_attributes',
  'collection_prod_click_attributes',
  'collection_atc_attributes',
  'search_prod_click_attributes',
  'general_atc_btn_attributes',
] as const;

/**
 * Empty the ecommerce click maps so f-find-elem.js matches nothing for them.
 * Navigation and content-engagement maps (header nav, accordions, banners)
 * are left in place. Must run after the CDN scripts have loaded — they define
 * the maps on load.
 */
export function disableCdnClickDetection(analyzify: Record<string, any>): void {
  for (const key of ECOMMERCE_CLICK_MAPS) {
    analyzify[key] = {};
  }
  // Custom add-to-cart window events the CDN would listen for on every click
  analyzify.global_atc_functions = [];
}
